export const columns: any[] = [
  {id: 'name', label: 'Integration Name'},
  {id: 'integrationType', label: 'Integration Type'},
  {id: 'area', label: 'Area'},
  {id: 'districtName', label: 'School District'},
  {id: 'schoolName', label: 'School Name'},
  {id: 'status', label: 'Status'},
  {id: 'actions', label: ''},
];
